import { Check } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useT, useLocalePath } from "@/i18n";

const FitCheck = () => {
  const lp = useLocalePath();
  const t = useT(
    {
      eyebrow: "Passgenauigkeit",
      heading: "Sie sind hier richtig, wenn …",
      intro:
        "Sie das Gefühl haben, dass einzelne Symptome nicht das ganze Bild erklären. Viele Menschen kommen zu mir, nachdem sie bereits einen längeren Weg hinter sich haben. Vielleicht gab es zahlreiche Untersuchungen, unterschiedliche Diagnosen oder verschiedene Therapieversuche – und trotzdem bleiben Fragen offen.",
      points: [
        "Ihre Beschwerden immer wieder zurückkehren oder sich verändern.",
        "Verschiedene Symptome auf den ersten Blick nicht zusammenzupassen scheinen.",
        "Sie bereits viele Befunde, Untersuchungen oder Therapieversuche hinter sich haben.",
        "Sie sich trotz \u201eunauffälliger\u201c Befunde nicht wirklich gesund fühlen.",
        "Bisherige Maßnahmen nur kurzfristig geholfen haben.",
        "Sie mögliche Zusammenhänge besser verstehen möchten.",
      ],
      cta: "Termin online buchen",
    },
    {
      eyebrow: "Good fit",
      heading: "This practice may be right for you if …",
      intro:
        "You have the feeling that individual symptoms do not explain the whole picture. Many people come to me after a long journey. Perhaps there have been numerous examinations, different diagnoses or various therapy attempts – and yet questions remain.",
      points: [
        "Your complaints keep returning or changing.",
        "Different symptoms do not seem to fit together at first glance.",
        "You already have many findings, examinations or therapy attempts behind you.",
        "Despite \u201cnormal\u201d findings, you do not really feel healthy.",
        "Previous measures have only helped in the short term.",
        "You would like to better understand possible connections.",
      ],
      cta: "Book an appointment online",
    },
  );

  return (
    <section id="bin-ich-hier-richtig" className="py-16 md:py-24 bg-secondary/30">
      <div className="container mx-auto px-4">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-12">
            <span className="text-primary font-medium text-sm uppercase tracking-wider">{t.eyebrow}</span>
            <h2 className="text-3xl md:text-4xl font-bold text-foreground mt-2 mb-6">{t.heading}</h2>
            <p className="text-muted-foreground leading-relaxed">{t.intro}</p>
          </div>

          <ul className="space-y-5">
            {t.points.map((point) => (
              <li key={point} className="flex items-start gap-4 text-foreground/90">
                <span className="mt-1 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary/10">
                  <Check className="h-3.5 w-3.5 text-primary" />
                </span>
                <span className="text-base leading-relaxed">{point}</span>
              </li>
            ))}
          </ul>

          <div className="mt-12 flex justify-center">
            <Button asChild size="lg" className="min-h-12">
              <Link to={lp("/termin")}>{t.cta}</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FitCheck;
